module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("在线数 / 总数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.onlineNum) + " / " + _vm._s(_vm.totalNum))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.executorList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入Executor"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.executorName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.executorName, "value", $$v)
            },
            expression: "filters.executorName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")]), _vm._v(" "), (_vm.$common.hasPerm('executor:shardAllAtOnce', _vm.domainName)) ? _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleReArrange()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        }), _vm._v("一键重排")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("Executor列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getExecutorList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('executor:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "executorName",
            "label": "Executor",
            "min-width": "160px",
            "show-overflow-tooltip": "",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.container) ? _c('i', {
                staticClass: "iconfont icon-docker"
              }) : _vm._e(), _vm._v(" "), (!scope.row.container) ? _c('i', {
                staticClass: "iconfont icon-zhuji"
              }) : _vm._e(), _vm._v("\n                                " + _vm._s(scope.row.executorName) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "status",
            "label": "状态",
            "width": "80px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.status === 'ONLINE' ? 'success' : '',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.translateStatus[scope.row.status]))]), _vm._v(" "), (scope.row.restarting) ? _c('el-tag', {
                attrs: {
                  "type": "warning"
                }
              }, [_vm._v("重启中")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "serverIp",
            "label": "IP",
            "width": "125px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "groupName",
            "label": "分组",
            "show-overflow-tooltip": "",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.groupName || '--') + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "运行中分片",
            "header-align": "left",
            "width": "95px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.status === 'OFFLINE') ? _c('span', [_vm._v("--")]) : _c('el-tooltip', {
                attrs: {
                  "content": "查看",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.getRunningAllocation(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search-plus"
              })])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "版本",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lastBeginTime",
            "label": "最近启动时间",
            "width": "160px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "150px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('executor:restart', _vm.domainName) && (scope.row.status === 'ONLINE' && !scope.row.restarting && _vm.isAbledDump(scope.row.version))) ? _c('el-tooltip', {
                attrs: {
                  "content": "重启",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleRestart(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-power-off"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:extractOrRecoverTraffic', _vm.domainName) && !scope.row.noTraffic) ? _c('el-tooltip', {
                attrs: {
                  "content": "摘取流量",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleTraffic(scope.row, 'extract')
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-stop-circle text-warning"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:extractOrRecoverTraffic', _vm.domainName) && scope.row.noTraffic) ? _c('el-tooltip', {
                attrs: {
                  "content": "恢复流量",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleTraffic(scope.row, 'recover')
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-play-circle"
              })])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 'ONLINE') ? _c('el-tooltip', {
                attrs: {
                  "content": "一键DUMP",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.$common.handleDump(scope.row, _vm.domainName, _vm.dumpNext.bind(this))
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-database"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:remove', _vm.domainName) && scope.row.status === 'OFFLINE') ? _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "分片分配查看",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.getExecutorAllocation(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-arrows-alt"
              })])], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isExecutorAllocationVisible) ? _c('div', [_c('executor-allocation-dialog', {
    attrs: {
      "executor-allocation-info": _vm.executorAllocationInfo
    },
    on: {
      "close-dialog": _vm.closeExecutorAllocationDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRunningAllocationVisible) ? _c('div', [_c('running-allocation-dialog', {
    attrs: {
      "running-allocation-info": _vm.runningAllocationInfo
    },
    on: {
      "close-dialog": _vm.closeRunningAllocationDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8b5a5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/executor_overview.vue
// module id = 1383
// module chunks = 1